"use client"
/* */
const inputGroup = "flow--password-creation-field--input-group";
const input = "flow--password-creation-field--input";
const buttonContainer = "flow--password-creation-field--button-container";
const button = "flow--password-creation-field--button";
const styles = {
	inputGroup: inputGroup,
	input: input,
	buttonContainer: buttonContainer,
	button: button
};

export { button, buttonContainer, styles as default, input, inputGroup };
//# sourceMappingURL=PasswordCreationField.module.scss.mjs.map
